<scrolldiv
  style="flex: 1 1 0%; overflow: hidden; width: 100%; height: 100%"
  [scrollerSize]="20"
  [navigatorSize]="14"
  [scrollVerticalIndent]="0"
  cls="lightScroll"
>
  <div [height]="20"></div>
  <div class="close-cnt cnt-row">
    <div [width]="20"></div>
    <div class="filler"></div>
    <simple-btn
      [width]="30"
      [height]="30"
      [cornerRadius]="20"
      [horizontalPadding]="0"
      [leftSpace]="0"
      [rightSpace]="0"
      [borderWidth]="2"
      [rightImgCls]="'btn-close'"
      [rightImgHoverCls]="'btn-close-hover'"
      [text]="''"
      [hoverFillCls]="'g4Background'"
      [textColorCls]="'g4Color'"
      [borderColorCls]="'g4Border'"
      [hoverBorderColorCls]="'g4Border'"
      [backgroundFillCls]="'g2Background'"
      (click)="onClose()"
      data-testid="closeBtn"
    >
    </simple-btn>
    <div [width]="20"></div>
  </div>
  <div>
    <span class="header-text-font-brixx" i18n>{{ 'SUBSCRIPTION_DETAILS' | translate }}</span><br />
  </div>
  <div [width]="10"></div>
  <div data-testid="billing-details">
    <div class="tabpane">
      <div class="cnt-row-centered">
        <div
          [height]="40"
          class="tab-btn h5Font g5Color cnt-row-centered"
          [ngClass]="{ 'g4Color inactive': !isManageBilling }"
          (click)="onManageBillingClick()"
          data-testid="ManageBillingTab"
        >
          <div i18n>{{ 'MANAGE_BILLING' | translate }}</div>
        </div>
      </div>

      <div *ngFor="let UserSubscription of UserSubscriptions; let i = index">
          <ng-container>
              <billing-subscription-pane [UserSubscription]="UserSubscription"></billing-subscription-pane>
          </ng-container>

          <div style="height: 20px"></div>
      </div>
      <div style="height: 10px"></div>
    </div>

    <div class="tabpane">
      <div class="cnt-row-centered">
        <div
          [height]="40"
          class="tab-btn h5Font g5Color cnt-row-centered"
          [ngClass]="{ 'g4Color inactive': !isDetailsActive }"
          (click)="onBillingClick()"
        >
          <div i18n>{{ 'BILLING_DETAILS' | translate }}</div>
        </div>
        <div [width]="2"></div>
        <div
          [height]="40"
          class="tab-btn h5Font g5Color cnt-row-centered"
          [ngClass]="{ 'g4Color inactive': isDetailsActive }"
          (click)="onPaymentClick()"
          data-testid="PaymentHistory-link"
        >
          <div i18n>{{ 'BILLING_HISTORY' | translate }}</div>
        </div>
      </div>
      <ng-container *ngIf="isDetailsActive; else paymentHistory">
        <billing-details-pane></billing-details-pane>
      </ng-container>
    </div>

    <ng-template #paymentHistory>
      <billing-payment-history-pane></billing-payment-history-pane>
    </ng-template>
    <div style="height: 20px"></div>
  </div>
</scrolldiv>
